/**
 * Cross-platform "share" helper.
 * On mobile (or any browser with the Web Share API) it opens the native
 * share sheet. Otherwise it copies the link to the clipboard.
 * Returns { method: "native" | "copy", ok: bool }.
 */
export async function shareLink({ title, text, url }) {
  const nav = typeof navigator !== "undefined" ? navigator : null;
  if (nav && typeof nav.share === "function") {
    try {
      await nav.share({ title, text, url });
      return { method: "native", ok: true };
    } catch (e) {
      // User cancelled or share failed — fall through to clipboard fallback.
      if (e && e.name === "AbortError") return { method: "native", ok: false, cancelled: true };
    }
  }
  try {
    if (nav?.clipboard?.writeText) {
      await nav.clipboard.writeText(url);
      return { method: "copy", ok: true };
    }
  } catch { /* noop */ }
  return { method: "copy", ok: false };
}

/** Build a share URL that points at the OG-tagged backend page for rich previews. */
export function roomShareUrl(slug) {
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${backend}/api/share/room/${encodeURIComponent(slug)}`;
}

export function pollShareUrl(pollId) {
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${backend}/api/share/poll/${encodeURIComponent(pollId)}`;
}
